var map = {
	"./afb-color.svg": 698,
	"./alb-color.svg": 699,
	"./all.svg": 700,
	"./amb-color.svg": 701,
	"./arg.svg": 702,
	"./aus.svg": 703,
	"./bank-icon.svg": 704,
	"./bankdemo-color.svg": 705,
	"./bel.svg": 706,
	"./bimb-color.svg": 707,
	"./bkr-color.svg": 708,
	"./bpay-color.svg": 709,
	"./bra.svg": 710,
	"./bsn-color.svg": 711,
	"./can.svg": 712,
	"./checked-green.png": 713,
	"./checked-white.png": 714,
	"./cimb-color.svg": 715,
	"./cimb-icon.svg": 716,
	"./citi-color.svg": 717,
	"./cmr.svg": 718,
	"./crc.svg": 719,
	"./cro.svg": 720,
	"./den.svg": 721,
	"./ecu.svg": 722,
	"./eng.svg": 723,
	"./esp.svg": 724,
	"./fav-blue.svg": 725,
	"./fav-gray.png": 726,
	"./fav-gray.svg": 727,
	"./fav-icon-active.png": 728,
	"./fav-icon.png": 729,
	"./fav-red.png": 730,
	"./fra.svg": 731,
	"./game-icon.svg": 732,
	"./games-active-m.svg": 733,
	"./ger.svg": 734,
	"./gha.svg": 735,
	"./gxbank-color.svg": 736,
	"./hlb-color.svg": 737,
	"./hlb-icon.svg": 738,
	"./hsbc-color.svg": 739,
	"./irn.svg": 740,
	"./jpn.svg": 741,
	"./kor.svg": 742,
	"./ksa.svg": 743,
	"./kwh-color.svg": 744,
	"./latest-icon-active.png": 745,
	"./latest-icon.png": 746,
	"./lc-active-m.svg": 747,
	"./lc-icon.svg": 748,
	"./lottery-active-m.svg": 749,
	"./lottery-icon.svg": 750,
	"./lottery-m.svg": 751,
	"./love.svg": 752,
	"./mar.svg": 753,
	"./mbb-color.svg": 754,
	"./mex.svg": 755,
	"./ned.svg": 756,
	"./ocbc-color.svg": 757,
	"./ocbc-icon.svg": 758,
	"./p2p-active-m.svg": 759,
	"./p2p-icon.svg": 760,
	"./p2p-m.svg": 761,
	"./pbb-color.svg": 762,
	"./pol.svg": 763,
	"./por.svg": 764,
	"./price-high.svg": 765,
	"./price-low.svg": 766,
	"./qat.svg": 767,
	"./rhb-color.svg": 768,
	"./rhb-icon.svg": 769,
	"./scb-color.svg": 770,
	"./sen.svg": 771,
	"./slot-active-m.svg": 772,
	"./slot-icon.svg": 773,
	"./sport-active-m.svg": 774,
	"./sports-icon.svg": 775,
	"./srb.svg": 776,
	"./star.svg": 777,
	"./sui.svg": 778,
	"./tng-color.svg": 779,
	"./trx-icon.svg": 780,
	"./trx.svg": 781,
	"./tun.svg": 782,
	"./uob-color.svg": 783,
	"./uru.svg": 784,
	"./usa.svg": 785,
	"./usdc.svg": 786,
	"./usdt.svg": 787,
	"./ustd-icon.svg": 788,
	"./wal.svg": 789,
	"./x33-logo-b.svg": 790,
	"./x33-square-icon.svg": 791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 119;